import React from "react";
import { useDispatch, useSelector } from "react-redux";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import ShowPicture from "./ShowPicture";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from "@material-ui/core/Switch";
import {
  deleteWaitingRoom,
  validatePersonsWaitingRoom
} from "../../utils/fetcher";
import Tooltip from "@material-ui/core/Tooltip";
import { translator } from "../../utils/i18n";

function WaitingRoom() {
  const infosWaitingRoom = useSelector(state => state.waitingRoom) || {};
  const dispatch = useDispatch();
  const validatePersonsWaitingRoomFun = id =>
    dispatch(validatePersonsWaitingRoom([id]));
  const deleteWaitingRoomFunc = id => dispatch(deleteWaitingRoom([id]));

  const handleChange = (event, id) => {
    if (event.target.checked) {
      validatePersonsWaitingRoomFun(id);
    } else {
      deleteWaitingRoomFunc(id);
    }
  };

  return (
    <div>
      <div className="custom-message custom-success d-flex align-items-center justify-content-start flex-nowrap p-6">
        <CheckCircleIcon /> {translator()._("W_INFORMER_MEDECIN")}
      </div>
      <List>
        {infosWaitingRoom.listPersons.map((item, key) => {
          const text = item.isInWaitingRoom ? (
            <>
              <div>{item.nameRoom}</div>
              <div>
                {item.civilityDoctor} {item.firstNameDoctor}
              </div>
            </>
          ) : (
            ""
          );
          return (
            <ListItem key={key} className="item-bloc" divider>
              <Tooltip
                title={
                  item.isInWaitingRoom
                    ? "Retirer de la liste d'attente"
                    : "Ajouter à la liste d'attente"
                }
                aria-label="add"
              >
                <FormControlLabel
                  control={
                    <Switch
                      checked={item.isInWaitingRoom}
                      onChange={e => handleChange(e, item.appointmentId)}
                      color="secondary"
                    />
                  }
                />
              </Tooltip>

              <ListItemText
                primary={`${item.firstName} ${item.lastName}`}
                secondary={text}
              />
              {item.pictureRoom && item.isInWaitingRoom && (
                <ShowPicture picture={item.pictureRoom} />
              )}
            </ListItem>
          );
        })}
      </List>
    </div>
  );
}

export default WaitingRoom;
